/** 顶栏空间有限，英文用短文案；完整含义可通过 tooltip 查看 */
export default {
  platformTitle: 'TermiTech Ops',
  platformTitleFull: 'TermiTech Heterogeneous Multi-Robot Platform',
  homeScreen: 'Home Screen',
  hcScreen: 'Retail Management',
  uavCenter: 'UAV Center',
  robotDogCenter: 'Robot Dog Center',
  robotCenter: 'Robot Center',
  businessCenter: 'Business Center',
  robotCenterOverall: 'Overall Control',
  robotCenterSmt: 'Smart Warehouse',
  smtJobOverview: 'Job Overview',
  smtJobOverviewDesc: 'Real-time summary of tasks, devices, and exceptions',
  smtDispatch: 'Simulated Dispatch',
  smtDispatchDesc: 'Configure stations and devices by process. One pick station maps to a 36-slot seeding wall that can hold multiple orders',
  smtTaskList: 'Task List',
  smtTaskListDesc: 'Each task has pick and check steps; all orders are shown by task by default',
  smtStationList: 'Station List',
  smtStationListDesc: 'Pick and check stations are paired by process type; each station maps to one seeding rack (4×9 = 36 slots)',
  smtDevice: 'Device Management',
  smtDeviceDesc: 'Manage smart warehouse device online status and basics',
  smtMaterialLib: 'Product Library',
  smtMaterialLibDesc: 'SKU-level inventory with bay layout, packaging specs, and grasp readiness',
  smtPagePlaceholder: 'Content coming soon',
  warehouseMonitor: 'Warehouse Management',
  productShowcase: 'Product Showcase',
  assistant: 'Assistant',
  systemSettings: 'Settings',
  logout: 'Sign Out',
}
